import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import apiClient from 'utils/apiClient';

export interface PushHistoryState {
    histories: PushHistoryProps[]
    loading: boolean
}

export interface PushHistoryProps {
    sent_at: number
    [key: string]: any
}

export const initialState: PushHistoryState = {
    histories: [],
    loading: false
};

export const searchPushHistories = createAsyncThunk<PushHistoryProps[], { deviceId: string, lteDate?: string }, { state: RootState }>(
    'pushHistory/search',
    async (params, { rejectWithValue }) => {
        const { deviceId, lteDate } = params;
        if (!deviceId) return;

        let url = `/api/history/push?deviceId=${encodeURIComponent(deviceId)}`;
        if (lteDate) url += `&lteDate=${encodeURIComponent(lteDate)}`;

        try {
            const response = await apiClient.get(url);
            return response.data.records;
        } catch (e: any) {
            return rejectWithValue(e?.response?.data?.msg || 'Failed to fetch push history');
        }
    },
    {
        condition: (_, { getState }) => {
            const { loading } = (getState() as RootState).pushHistory as PushHistoryState;
            return !loading;
        }
    }
)

const pushHistorySlice = createSlice({
    name: "pushHistory",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(searchPushHistories.pending, (state) => {
                state.loading = true;
            })
            .addCase(searchPushHistories.fulfilled, (state, action) => {
                state.loading = false;
                if (!action.payload) return;
                // API returns ASC, reverse to get DESC (newest first)
                state.histories = [...action.payload].reverse();
            })
            .addCase(searchPushHistories.rejected, (state) => {
                state.loading = false;
            })
    },
    reducers: {
        refresh: () => initialState,
    }
})

export const {
    refresh
} = pushHistorySlice.actions;
export default pushHistorySlice.reducer;
